globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};

appCustomerSpace.Controllers.Public.WelcomeLocalManagementDiscoveryFunnelController = (function (superClass) {

  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function () {
      this._initEvents();

      return MainController.__super__.init.apply(this, arguments);
    },
    prepare_audit: function () {
      appCustomerSpace.Loader().start({ $container: $('.generate-audit-loader'), options: { style: { backdrop: { background: "#fff" } } } });

      $.ajax({
        url: "/bienvenue/audit-fiche-google/generate_audit",
        method: 'POST',
        success: function (data) {
          $('body').trigger('sb.localManagementDiscoveryFunnel.completed');
          if (data.redirect_url) {
            window.location = data.redirect_url
          }
        },
        error: function (data) { }
      });

      setTimeout(function () {
        appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Connexion à votre fiche Google...", style: { backdrop: { background: "#fff" } } } });
        setTimeout(function () {
          appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Récupération des informations...", style: { backdrop: { background: "#fff" } } } });
          setTimeout(function () {
            appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Récupération des photos...", style: { backdrop: { background: "#fff" } } } });
            setTimeout(function () {
              appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Récupération des avis...", style: { backdrop: { background: "#fff" } } } });
              setTimeout(function () {
                appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Analyse de votre fiche...", style: { backdrop: { background: "#fff" } } } });
                setTimeout(function () {
                  appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Calcul de votre score...", style: { backdrop: { background: "#fff" } } } });
                  setTimeout(function () {
                    appCustomerSpace.Loader().set({ $container: $('.generate-audit-loader'), options: { text: "Mise en forme de votre audit...", style: { backdrop: { background: "#fff" } } } });
                  }, 2000);
                }, 2000);
              }, 2000);
            }, 2000);
          }, 2000);
        }, 2000);
      }, 1000);
    },
    _initEvents: function () {
      $('.job-category-select-form-group select').on('change', function () {
        if ($(this).val() != undefined) {
          $(this).closest('form').find('.job-select-form-group').show();
        }
      });

      var $resultsContainer = $('#location-search-results-container'),
      ajaxUrl = $resultsContainer.data('ajax-url'),
      errorMsg = 'Erreur de chargement des fiches Google',
      queryString = window.location.search;

      appCustomerSpace.Loader().start({ $container: $resultsContainer, options: { style: { backdrop: { background: "#fff" } } } });

      if(ajaxUrl) {
        $.get(ajaxUrl + queryString, function(data) {
          if(data.response) {
            appCustomerSpace.Loader().stop({ $container: $resultsContainer }, function() {
              $resultsContainer.append(data.html);
            });
          } else {
            alert(errorMsg);
          }
        }).fail(function() {
          alert(errorMsg);
        });
      } else {
        appCustomerSpace.Loader().stop({ $container: $resultsContainer });
      };
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.Public.MainController);
